import React, { type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { SortableList } from 'mailup-web-components'

import ColumnItem from 'Pages/RecipientsList/components/columns/ColumnItem'

import { panelConfigColumnsReorderCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'
import { panelConfigColumnsState } from 'Pages/RecipientsList/recoil/state/configColumns'

const ColumnsList: FC = () => {
  const { items: cols } = useRecoilValue(panelConfigColumnsState)

  const columnsReorder = useRecoilCallback(
    panelConfigColumnsReorderCallback,
    [],
  )

  const items = cols.map((c, i) => ({
    content: <ColumnItem index={i} canDelete={cols.length > 1} />,
    canMove: true,
  }))

  const handleChange = ({
    type,
    payload: { from, to },
  }: {
    type: 'reorder'
    payload: {
      from: number
      to: number
    }
  }): void => {
    void columnsReorder(from, to)
  }

  return (
    <SortableList items={items} onChange={handleChange} emptyState={null} />
  )
}

export default ColumnsList
